import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Loader from '../../components/Global/Loader'
import Consultations from '../../components/Admin/Dashboard/ConsultationsData'
import Applications from '../../components/Admin/Dashboard/ApplicationsCharts'
import Consultants from '../../components/Admin/Dashboard/ConsultantsCounts'  
// import UniversitiesCards from '../../components/Admin/Dashboard/UniversitiesCards'


function Dashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [consultations, setConsultations] = useState([]);
  const [consultationsStats, setConsultationsStats] = useState({});
  const [applicationsStats, setApplicationsStats] = useState({});
  const [consultantsStats, setConsultantsStats] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/dashboard`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (response?.data?.success) {
          setConsultations(response.data.data.latestConsultations);
          setConsultationsStats(response.data.data.consultationsStats);
          setApplicationsStats(response.data.data.applicationsStats);
          setConsultantsStats(response.data.data.consultantsStats);
        }
      } catch (error) {
        alert(error?.response?.data?.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [])

  if(isLoading) return <Loader />

  return (
    <>
      <div id="main-content" className="relative pl-36 mt-16 w-full p-8 bg-[#f4f8fb]">
        <Consultations consultations={consultations} consultationsStats={consultationsStats} />
        <Applications applicationsStats={applicationsStats} />
        <Consultants consultantsStats={consultantsStats} />
      </div>
    </>
  )
}

export default Dashboard
